import { useAccessToken } from "./useAccessToken";
import { useTenantGet } from "@/features/profile-settings/hooks/useTenantGet";
import { useTenantGetPublic } from "@/features/profile-settings/hooks/useTenantGetPublic";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

const TENANT_ID = resolveEffectiveTenantNumber();

export const useTenantData = () => {
  const accessToken = useAccessToken();
  const usePublicTenant = !accessToken;

  const {
    data: authenticatedData,
    isPending: isAuthenticatedPending,
    isLoading: isAuthenticatedLoading,
    isError: isAuthenticatedError,
    isSuccess: isAuthenticatedSuccess,
    refetch: refetchAuthenticated,
    isFetching: isAuthenticatedFetching,
  } = useTenantGet({ tenantId: TENANT_ID }, { enabled: !!accessToken });

  const {
    data: publicData,
    isLoading: isPublicLoading,
    isError: isPublicError,
    isSuccess: isPublicSuccess,
  } = useTenantGetPublic(
    { tenantId: TENANT_ID },
    { enabled: usePublicTenant },
  );

  const data = authenticatedData ?? publicData;
  const isPending = usePublicTenant ? isPublicLoading : isAuthenticatedPending;
  const isLoading = usePublicTenant ? isPublicLoading : isAuthenticatedLoading;

  return {
    tenantData: data,
    isPending,
    isLoading,
    isError: usePublicTenant ? isPublicError : isAuthenticatedError,
    isSuccess: usePublicTenant ? isPublicSuccess : isAuthenticatedSuccess,
    tenantId: TENANT_ID,
    refetch: () => {
      void refetchAuthenticated();
    },
    isFetching: isAuthenticatedFetching,
  };
};
